<div fxLayout="row" fxLayoutAlign="space-between center" class="container">

    <div [ngClass]="whichStep == 1 ? 'active' : 'inactive'" fxLayout="row" fxLayoutAlign="space-between center">
        <app-notification-badge 
        [displayString]="'1'" 
        [size]="'large'"
        [color]="stepOneColor"></app-notification-badge>
        <span class="pd-left-5">Register Primary Account</span>
    </div>
    
    <div class="horizontal-line"></div>

    <div [ngClass]="whichStep == 2 ? 'active' : 'inactive'" fxLayout="row" fxLayoutAlign="space-between center">
        <app-notification-badge 
        [displayString]="'2'" 
        [size]="'large'"
        [color]="stepTwoColor"></app-notification-badge>
        <span class="pd-left-5">Select a Course</span>
    </div>
    
    <div class="horizontal-line"></div>

    <div [ngClass]="whichStep == 3 ? 'active' : 'inactive'" fxLayout="row" fxLayoutAlign="space-between center">
        <app-notification-badge 
        [displayString]="'3'" 
        [size]="'large'"
        [color]="stepThreeColor"></app-notification-badge>
        <span class="pd-left-5">Start Free Diagnostic</span>
    </div>
    
</div>
     
